export const GET_QRCODE_REQUEST = "GET_QRCODE_REQUEST";
export const GET_QRCODE_SUCCESS = "GET_QRCODE_SUCCESS";
export const GET_QRCODE_FAIL = "GET_QRCODE_FAIL";
export const RESET_QRCODE_REQUEST = "RESET_QRCODE_REQUEST";
